import { breakpoints, css } from 'src/styles/theme';
import { rem } from 'polished';

export const StylesOVGB = css`
    background-color: ${({ theme }) => theme.colors.pureWhite};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    max-height: fit-content;
    min-height: ${rem(60)};

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(16)} ${rem(24)};

        &.SOL-filter {
            padding: ${rem(16)} ${rem(24)};
        }
    }

    .grid-button {
        min-width: ${rem(120)};
        text-transform: uppercase;
        font-weight: ${({ theme }) => theme.fontWeights.textMedium};
        color: ${({ theme }) => theme.colors.grey2};
        background: unset;
        text-align: left;
        padding: 0 ${rem(15)};
        &:hover:hover:not(:active),
        &:hover:not(:disabled),
        &:focus-visible:not(:disabled) {
            border-color: ${({ theme }) => theme.colors.grey2} ${({ theme }) => theme.colors.grey2}
                ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.grey2};
            background: ${({ theme }) => theme.colors.white};
            border-bottom-width: ${rem(2)};
        }

        &.active {
            &::after {
                content: '';
                border: ${rem(1)} solid ${({ theme }) => theme.colors.primary};
                width: 100%;
                position: absolute;
                left: 0px;
                bottom: 0px;
            }
        }
    }

    .slider-over {
        /* FYI calc has its reasons due to style override, you do not want dead 1px on md BP */
        @media (max-width: calc(${breakpoints.md}px - 0.1px)) {
            width: 90%;
        }
    }

    .toggle-filters {
        text-transform: uppercase;

        @media (max-width: calc(${breakpoints.xs}px - 0.1px)) {
            height: ${rem('40px')};
            font-size: ${rem('16px')};
        }
    }

    .reset-filters-button {
        font-size: ${rem(14)};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        line-height: ${rem(18)};
        color: ${({ theme }) => theme.colors.grey11};
        font-weight: 700;
    }

    .fuel-title,
    .gearbox-title,
    .budget-title {
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-weight: ${({ theme }) => theme.fontWeights.textMedium};
        font-size: ${rem(16)};
        color: ${({ theme }) => theme.colors.grey12};

        @media (min-width: ${breakpoints.md}px) {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .hiddenFilters {
        display: none;
    }

    .rc-slider {
        .rc-slider-track {
            background-color: ${({ theme }) => theme.colors.primary};
        }
        .rc-slider-handle {
            border-color: ${({ theme }) => theme.colors.grey1};
            background-color: ${({ theme }) => theme.colors.grey8};
        }
    }
`;
